import { render, staticRenderFns } from "./SoftwareDownloading.vue?vue&type=template&id=fd5e67b2&scoped=true&"
import script from "./SoftwareDownloading.vue?vue&type=script&lang=js&"
export * from "./SoftwareDownloading.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareDownloading.vue?vue&type=style&index=0&id=fd5e67b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5e67b2",
  null
  
)

export default component.exports